import AppNotifications from "./AppNotifications";
import ThemeContextCover from "./ThemeContextCover";
import isBrowserSupported from "./browserSupportCheck";
import SignInWithDevAccountButton from "./SignInWithDevAccountButton";
import { SIGNIN, PAYMENT, NEW_FEATURES, REPORT_BUG } from './AppModal';
import G from './Getters';
import { useState } from 'react';
import HelpPopover from './HelpPopover';
import UserSettingsButton from './UserSettingsButton';
import ExitTutorialButton from './ExitTutorialButton';
import Navbar from './Navbar';
import SaveButton from './SaveButton';
import { ANTIBODIES } from './UIConstants';
//import SignInWithDevAccountButton from './SignInWithDevAccountButton';
//import SignInWithGoogleButton from './SignInWithGoogleButton';

import { useDispatch } from 'react-redux';


import CloudSyncToolbarItem from './CloudSyncToolbarItem';

import CloudBackupButton from './CloudBackupButton';


import MenuIcon from '@material-ui/icons/Menu';
import MainDrawer from './MainDrawer';

import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import PeopleIcon from '@material-ui/icons/People';
import pingServer from './pingServer';


import { MAIN_FIGURE_ID, SCREENSHOT_IGNORE } from './UIConstants';



const QUANTIFICATION_FEATURE = true;

const SETTINGS = "SETTINGS";
const FIGURE="FIGURE";
const IMAGES="IMAGES";
const ANNOTATION="ANNOTATION";
const DEMO = "DEMO";
const QUANTIFICATION = "QUANTIFICATION";
const ANTIBODY_VALIDATION = "ANTIBODY_VALIDATION";
const FIGURES_AND_PANELS = "FIGURES_AND_PANELS";
const IMAGE_STORAGE = "IMAGE_STORAGE";
const WESTERN_BLOTS = false && "WESTERN_BLOTS";/// && false;
const PLATES = "PLATES";
const PLOT_TEST = "PLOT_TEST";
const PROTOCOLS = "PROTOCOLS";
const INVENTORY = "INVENTORY";
const PUBLICATIONS = "PUBLICATIONS";

const options = [
  { _id:ANNOTATION, label:"Upload and Label" },
  { _id:QUANTIFICATION, label:"Quantification" },
  { _id:FIGURES_AND_PANELS, tab:"figurePanels", label:"My Figures" },
  /*{ _id:ANTIBODIES, tab:"antibodies", label:"Antibodies" },*/
  /*
  { _id:PLATES, label:"Plates" },
  { _id:INVENTORY, label:"Inventory" },
  { _id:PUBLICATIONS, label:"Publications" },
  */
]

if( process.env.NODE_ENV === "development" ){
  options.push({
    _id:"PLAYGROUND", label:"Playground"
  })
}


function HelpItem({onClick,menuButtonStyle}){
  return (

    <div id="new-features" style={{...menuButtonStyle,alignItems:'center',display:'flex', 
        //width:25,
        justifyContent:'center',
        //height:25
      }} 
        onClick={() => onClick(NEW_FEATURES)} 

        className={"hoverable round-corners tiny-margin small-padding"}>
        <HelpOutlineIcon style={{
          display:'flex',
          alignItems:'center',
          justifyContent:'center',
          fontSize:20,padding:-1,height:'100%'}}/>
      </div>
  )
}


export default function AppNavbar({mode,setMode,
  state, 
  setModal,
  setCommentModalOpen, name, 
  setCollaboratorFormOpen, 
  isLoggedIn,
  clearUserSelections,
}){

  let doingTutorial = G.isInTutorial(state);

  

  const [ drawerOpen, setDrawerOpen ] = useState(false);
  const [ shouldThrowError, setShouldThrowError ] = useState(false);

  if( shouldThrowError ){
    throw Error("ERROR");
  }

 
  let devSignin = <div><SignInWithDevAccountButton/></div>;
  if( process.env.NODE_ENV === "production" ){
    devSignin = null;
  }


  let menuButtonStyle = { fontSize:12, display:'flex', alignItems:'center' };

  let browser = isBrowserSupported();
  let { agent, supported } = browser;


  return (
    <div style={{
    }} class="sg-row border-bottom v-center rel">

      <ThemeContextCover style={{
        height:'calc(100% + 1px)',
      }}/>
      <Navbar {...{
        options,
        selected:mode,
        onSelect:setMode,
        spread:false,
        name:"main",
        style:{ fontSize:12, margin:3, },
      }}/>

      <div className="flex-expand"/>

      {false && !supported && <div style={{
        background:'pink',
        border:'3px solid red',
        borderRadius:3,
      }}><b>{agent}</b> unsupported. <b>Chrome</b> recommended.</div>}

      <HelpItem onClick={setMode} menuButtonStyle={menuButtonStyle}/>
      

      {window.__TESTING_ERROR === true && <h6 id="throw-error" style={menuButtonStyle} 
        onClick={() => {setShouldThrowError(true)}}
        className={"small-padding hoverable round-corners tiny-margin"}>Throw</h6>}



      
     
      {devSignin}



      {doingTutorial && <ExitTutorialButton/>}

      {!doingTutorial && <>


        {isLoggedIn && <div><SaveButton/></div>}

        {!isLoggedIn && null && (<div style={{...menuButtonStyle,
          // background:'red',
          marginRight:10,fontWeight:'bold'}}>
          <button button="open-auth-modal" onClick={() => setModal(SIGNIN)} style={{fontWeight:'bold'}} className="btn btn-primary btn-sm sg-row">Sign in</button>
        </div>)}

        {false && (false||isLoggedIn) && !doingTutorial && (
        <div>Lab Context</div>
      )}

        {true && (
          <>
            <div class="sg-row v-center" info="user-email">{state.loginInfo.username}</div>
            <UserSettingsButton {...{setMode,clearUserSelections,
              openSettingsModal:() => setModal(SETTINGS),
              openBugModal:()=>setModal(REPORT_BUG)}}/>
          </>
        )}
      </>}

      {!doingTutorial && (
        <div style={{
          position:'absolute',
          left:'50%',
          top:'50%',
          transform:'translate(-50%,-50%)',
        }}>
          <AppNotifications/>
        </div>
      )}

      

      

    </div>
  );
   
}
